import { usePage } from "@inertiajs/react";

export const useParams = <T extends Record<string, string>>(): T => {
    return usePage<{ params: T }>()?.props?.params || {};
};
